import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import CardCarrito from "../../ui/cardCarrito/CardCarrito";
import { X } from "lucide-react";
import axios from "axios";

export const fetchCarrito = async (token) => {
  try {
    const res = await axios.post(
      "https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/conseguir-carrito",
      {
        httpMethod: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, fk_idarea: 4704 }),
        isBase64Encoded: false,
      }
    );
    return JSON.parse(res.data.body);
  } catch {
    return [];
  }
};

export const getCarritoInvitado = async (productos) => {
  try {
    const res = await axios.post(
      "https://43a8phnwnh.execute-api.us-east-1.amazonaws.com/prod/get-producto/invitado",
      {
        httpMethod: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productos, area: 4704 }),
        isBase64Encoded: false,
      }
    );
    return JSON.parse(res.data.body);
  } catch {
    return [];
  }
};

const Carrito = ({ isOpen, setIsOpen }) => {
  const carritoRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const [usdPrice, setUsdPrice] = useState(0);
  const precioDolar = useSelector((state) => state.dolarPrice) || (usdPrice && usdPrice[0].importeARS);
  const [carrito, setCarrito] = useState([]);

  const loadInvitado = async () => {
    const invStore = localStorage.getItem("carrito-sce-product-manager");
    const invProd = invStore ? JSON.parse(invStore) : [];
    const arr = await getCarritoInvitado(invProd);
    setCarrito(arr);
  };

  const loadAutenticado = async () => {
    const arr = await fetchCarrito(token);
    setCarrito(arr);
  };

  const reloadCart = async () => {
    const response = await axios.get(`https://5fmuobow2m.execute-api.us-east-1.amazonaws.com/prod/get-datos-moneda`)
    setUsdPrice(JSON.parse(response.data.body))
    if (token) {
      await loadAutenticado();
    } else {
      await loadInvitado();
    }
  };

  useEffect(() => {
    const handler = () => reloadCart();
    window.addEventListener("cartUpdated", handler);
    return () => window.removeEventListener("cartUpdated", handler);
  }, []);

  useEffect(() => {
    if (isOpen) {
      reloadCart();
    }
  }, [isOpen]);

  const precioTotal = carrito && carrito.length > 0 && carrito.reduce((previous, current) => {
    const usd = current.precio_dolar * precioDolar;
    const pct = Number(current.porcentaje_promo) || 0;
    const qty = Number(current.cantidad_promo) || 0;
    const base = pct ? usd * (1 - pct / 100) : qty ? usd - qty : usd;
    const final = (base * current.cantidad).toFixed(0);
    return previous + Number(final);
  }, 0);

  return (
    <div>
      {isOpen && (
        <div
          className="z-[2200] w-full absolute"
          ref={carritoRef}
          onClick={(e) => {
            if (e.target === carritoRef.current) {
              setIsOpen(false);
            }
          }}
        >
          <div className="fixed top-8 lg:w-1/3 w-full bottom-0 right-0 bg-white shadow-2xl z-50">
            <div className="mx-7">
              <h1 className="my-5 text-sm font-bold text-left">
                TU CARRITO &gt; {carrito && carrito.length} producto/s
              </h1>
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-5 right-7 text-gray-500 hover:text-gray-800 cursor-pointer"
              >
                <X className="w-5" />
              </button>
              <div className="border-t-2 border-opacity-50 mb-3"></div>
              <div className="overflow-x-auto max-h-[calc(100vh-270px)]">
                <div className="flex flex-col">
                  {carrito && carrito.length > 0 && loading ? (
                    carrito.map((item) => (
                      <div key={item.idproducto}>
                        <CardCarrito
                        setCarrito={setCarrito}
                          item={item}
                          dolar={precioDolar}
                          setLoading={setLoading}
                          onCartChange={reloadCart}
                        />
                        <div className="border-t-2 my-2 border-opacity-30"></div>
                      </div>
                    ))
                  ) : (
                    <div className="flex justify-center items-center mt-32 mb-60">
                      <span className="sr-only">Loading...</span>
                    </div>
                  )}
                </div>
              </div>
              {carrito && carrito.length > 0 ? (
                <div>
                  <div className="flex flex-col">
                    <div className="flex flex-row text-sm justify-between mb-1">
                      <p className="font-medium">Totales:</p>
                      <p>
                        {precioTotal.toLocaleString("es-AR", {
                          style: "currency",
                          currency: "ARS",
                          maximumFractionDigits: 0,
                        })}
                        .-
                      </p>
                    </div>
                    <div className="border-b-2"></div>
                      <a className="border uppercase my-1 bg-[#E40F1B] text-[13px] py-2 rounded-md hover:bg-red-400 text-white mt-1" href="/carrito">
                        Continuar Compra
                      </a>
                  </div>
                </div>
              ) : loading ? (
                <div className="font-semibold">No hay productos</div>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Carrito;
